import React from 'react'

import { Error } from '@mui/icons-material'

interface ErrorBoundaryProps {
    text: string
}
export default class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
    state = {
        hasError: false,
    }
    static defaultProps = {
        text: 'Something went wrong.'     
    }
  
    static getDerivedStateFromError(error: any) {
      return { hasError: true }
    }
  
    componentDidCatch(error: any, errorInfo: any) {
      console.error(error, errorInfo)
    }
  
    render() {
      if (this.state.hasError) {
        return (
            <div style={{ display: 'flex', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}>
                <Error htmlColor="red" />
                <h1>{this.props.text}</h1>
            </div>
        )
      }
  
      return this.props.children
    }
  }